import { FC, SVGProps } from 'react';

export const ContactBookIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M20.7701 4.28864H12.0834C10.432 4.2896 8.84852 4.94622 7.68101 6.11418C6.5135 7.28215 5.8575 8.86588 5.85718 10.5173V20.4827C5.85718 23.9225 8.64487 26.7114 12.0846 26.7114H20.7713C24.2111 26.7114 27 23.9237 27 20.4827V10.5185C27 7.07875 24.2123 4.28985 20.7713 4.28985M3.987 11.1403H7.72372M3.987 19.8597H7.72372"
			stroke="currentColor"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.5959 9.31213C18.5954 9.31219 20.2204 10.9114 20.2204 12.8886C20.2203 14.0787 19.6299 15.131 18.7253 15.7805C20.6822 16.413 22.3372 17.9874 22.7755 20.5046C22.8272 20.8024 22.6242 21.082 22.3274 21.1324C22.0312 21.1825 21.7463 20.9867 21.6942 20.6896C21.212 17.9199 18.9769 16.543 16.6739 16.5474C14.3674 16.5518 12.0718 17.9436 11.4943 20.7067C11.4325 21.0019 11.1406 21.1889 10.8462 21.1292C10.5515 21.069 10.3581 20.7832 10.4194 20.4875C10.9323 18.0329 12.5867 16.4721 14.5189 15.8169C13.5848 15.1707 12.9714 14.1015 12.9713 12.8886C12.9714 10.9114 14.5963 9.31214 16.5959 9.31213ZM16.5959 10.3998C15.1981 10.3998 14.0687 11.516 14.0686 12.8886C14.0688 14.2611 15.1981 15.3784 16.5959 15.3784C17.9935 15.3783 19.123 14.2611 19.1231 12.8886C19.123 11.516 17.9936 10.3999 16.5959 10.3998Z"
			fill="currentColor"
		/>
	</svg>
);
